import { j as a } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { F } from "../../chunks/ChevronLeft20.CgL7KAAg.js";
import { F as z } from "../../chunks/ChevronRight20.XQ503sZW.js";
import { F as I } from "../../chunks/MoreHorizontal20.D_05FUdz.js";
import { c as f } from "../../chunks/index.CxSWpsOB.js";
import { c as R } from "../../chunks/index.C4-GUKyp.js";
const A = R("tw-relative tw-inline-flex tw-size-44 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-4 tw-border-0 tw-bg-transparent tw-body-2-m tw-cursor-pointer tw-outline-0 tw-outline-blue-800 tw-outline-offset-1 focus-visible:tw-outline-2", {
  variants: {
    // `aria-current` page — the cell the user is on.
    isActive: {
      true: "tw-bg-gray-900 tw-text-base-white",
      false: "tw-bg-base-white tw-text-gray-900 hover:tw-bg-gray-200"
    },
    // Used by the chevrons at the first/last page. Keeps the white surface
    // but greys the icon and drops interactivity.
    disabled: {
      true: "tw-text-gray-500 tw-pointer-events-none tw-cursor-default hover:tw-bg-base-white",
      false: ""
    }
  },
  defaultVariants: {
    isActive: !1,
    disabled: !1
  }
});
function E({
  className: i,
  ...t
}) {
  return /* @__PURE__ */ a.jsx("nav", { role: "navigation", "aria-label": "pagination", "data-slot": "pagination", className: f("tw-mx-auto tw-flex tw-w-full tw-justify-center", i), ...t });
}
function $({
  className: i,
  ...t
}) {
  return /* @__PURE__ */ a.jsx("ul", { "data-slot": "pagination-content", className: f("tw-flex tw-flex-row tw-items-center tw-gap-8", i), ...t });
}
function h(i) {
  return /* @__PURE__ */ a.jsx("li", { "data-slot": "pagination-item", ...i });
}
function v({
  className: i,
  isActive: t,
  disabled: n,
  href: s,
  children: o,
  ...r
}) {
  const l = {
    "aria-current": t ? "page" : void 0,
    "aria-disabled": n || void 0,
    "data-slot": "pagination-link",
    "data-active": t,
    className: f(A({
      isActive: t,
      disabled: n
    }), i),
    ...r
  };
  return s && !n ? /* @__PURE__ */ a.jsx("a", { href: s, ...l, children: o }) : /* @__PURE__ */ a.jsx("button", { type: "button", disabled: n, ...l, children: o });
}
function D({
  ariaLabel: i = "Previous page",
  ...t
}) {
  return /* @__PURE__ */ a.jsx(v, { "aria-label": i, ...t, children: /* @__PURE__ */ a.jsx(F, { className: "tw-size-20", "aria-hidden": !0 }) });
}
function S({
  ariaLabel: i = "Next page",
  ...t
}) {
  return /* @__PURE__ */ a.jsx(v, { "aria-label": i, ...t, children: /* @__PURE__ */ a.jsx(z, { className: "tw-size-20", "aria-hidden": !0 }) });
}
function y({
  className: i,
  srLabel: t = "More pages",
  ...n
}) {
  return /* @__PURE__ */ a.jsxs("span", { "data-slot": "pagination-ellipsis", className: f("tw-inline-flex tw-size-44 tw-shrink-0 tw-items-center tw-justify-center tw-text-gray-900", i), ...n, children: [
    /* @__PURE__ */ a.jsx(I, { className: "tw-size-20", "aria-hidden": !0 }),
    /* @__PURE__ */ a.jsx("span", { className: "tw-sr-only", children: t })
  ] });
}
const c = "ellipsis", j = (i, t) => Array.from({
  length: Math.max(t - i + 1, 0)
}, (n, s) => i + s), G = ({
  page: i,
  count: t,
  siblingCount: n = 1,
  boundaryCount: s = 1
}) => {
  if (t <= 0) return [];
  const o = j(1, Math.min(s, t)), r = j(Math.max(t - s + 1, s + 1), t), l = Math.max(Math.min(i - n, t - s - n * 2 - 1), s + 2), w = Math.min(Math.max(i + n, s + n * 2 + 2), r.length > 0 ? r[0] - 2 : t - 1);
  return [
    ...o,
    // start ellipsis, or the single page that fills the gap
    ...l > s + 2 ? [c] : s + 1 < t - s ? [s + 1] : [],
    ...j(l, w),
    // end ellipsis, or the single page that fills the gap
    ...w < t - s - 1 ? [c] : t - s > s ? [t - s] : [],
    ...r
  ];
};
function O({
  currentPage: i,
  totalPages: t,
  onPageChange: n,
  getPageHref: s,
  siblingCount: o = 1,
  boundaryCount: r = 1,
  className: l,
  previousAriaLabel: w = "Previous page",
  nextAriaLabel: N = "Next page",
  ellipsisLabel: b = "More pages",
  getPageAriaLabel: k = (m) => `Go to page ${m}`
}) {
  const m = G({
    page: i,
    count: t,
    siblingCount: o,
    boundaryCount: r
  }), x = i <= 1, d = i >= t, p = (e) => {
    e < 1 || e > t || e === i || n?.(e);
  }, u = "tw-hidden sm:tw-block", g = "tw-border tw-border-solid tw-border-gray-400 sm:tw-border-0";
  return /* @__PURE__ */ a.jsx(E, { className: l, children: /* @__PURE__ */ a.jsxs($, { children: [
    /* @__PURE__ */ a.jsx(h, { children: /* @__PURE__ */ a.jsx(D, { ariaLabel: w, className: g, disabled: x, href: !x && s ? s(i - 1) : void 0, onClick: (e) => {
      x || (s || e.preventDefault(), p(i - 1));
    } }) }),
    m.map((e, M) => /* @__PURE__ */ a.jsx(h, { className: u, children: e === c ? /* @__PURE__ */ a.jsx(y, { srLabel: b }) : /* @__PURE__ */ a.jsx(v, { isActive: e === i, "aria-label": k(e), href: s ? s(e) : void 0, onClick: (L) => {
      s || L.preventDefault(), p(e);
    }, children: e }) }, e === c ? `ellipsis-${M}` : e)),
    /* @__PURE__ */ a.jsx(h, { children: /* @__PURE__ */ a.jsx(S, { ariaLabel: N, className: g, disabled: d, href: !d && s ? s(i + 1) : void 0, onClick: (e) => {
      d || (s || e.preventDefault(), p(i + 1));
    } }) })
  ] }) });
}
O.displayName = "PaginationControls";
export {
  c as PAGINATION_ELLIPSIS,
  E as Pagination,
  $ as PaginationContent,
  O as PaginationControls,
  y as PaginationEllipsis,
  h as PaginationItem,
  v as PaginationLink,
  S as PaginationNext,
  D as PaginationPrevious,
  G as getPaginationRange
};
//# sourceMappingURL=index.js.map
